import {
    REPORTS_EXPORT_HISTORY_REQUEST,
    REPORTS_EXPORT_HISTORY_RESULT,
    REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST,
    REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    result: null,
    nextToken: null,
    refreshExportLogUrlLoading: false,
    refreshExportLogUrlResult: null,
    refreshExportLogUrlError: false,
    refreshExportLogUrlCurrentId: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case REPORTS_EXPORT_HISTORY_REQUEST:
            return { ...state, loading: true }

        case REPORTS_EXPORT_HISTORY_RESULT:
            return {
                ...state,
                loading: false,
                result: action?.payload?.nextToken
                    ? [...state.result, ...action?.payload?.result?.items]
                    : action?.payload?.result?.items,
                nextToken: action?.payload?.result?.nextToken
            }

        case REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_REQUEST:
            return {
                ...state,
                refreshExportLogUrlLoading: true,
                refreshExportLogUrlResult: null,
                refreshExportLogUrlError: false,
                refreshExportLogUrlCurrentId: action?.payload?.input?.exportLogId || null,
            }

        case REPORTS_EXPORT_HISTORY_REFRESH_EXPORT_LOG_URL_RESULT:
            return {
                ...state,
                refreshExportLogUrlLoading: false,
                refreshExportLogUrlResult: action?.payload?.result || null,
                refreshExportLogUrlError: !!action?.payload?.error,
                refreshExportLogUrlCurrentId: action?.payload?.exportLogId || null,
            }

        case CLEAR_REDUX:
            return ["", "REPORTS_EXPORT_HISTORY"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};
